export const rightsData = {
  medical: [
    {
      title: "Ghid Dispozitive Medicale (Procedură CAS)",
      body: "Cum poți obține scaune rulante, orteze sau aparate auditive gratuit prin CAS.",
      steps: [
        "PASUL 1: Obții o prescripție de la medicul specialist (nu cel de familie).",
        "PASUL 2: Depui dosarul la Casa de Asigurări de Sănătate (CAS) pentru Decizia de procurare.",
        "PASUL 3: Mergi la furnizorul agreat în termen de 30 de zile."
      ],
      tips: "Dacă prețul depășește suma decontată de CAS, poți cere DGASPC să acopere diferența din fonduri speciale."
    },
    { title: "Dispozitive medicale gratuite (Art. 11)", body: "Drept garantat la proteze (ORL, stomii, membre), dispozitive de mers, cărucioare și implanturi cardiace." },
    { title: "Bilet gratuit de tratament balnear", body: "Un singur bilet pe an, pe baza recomandării medicului. Însoțitorul are gratuitate la masă și cazare." }
  ],
  transport: [
    {
      title: "Credite Bancare Auto (Dobândă 0%)",
      body: "Statul plătește întreaga dobândă pentru credite destinate achiziției auto sau adaptării locuinței.",
      steps: [
        "Obții adeverința de acord de la DGASPC.",
        "Contractezi creditul de la bancă.",
        "Depui contractul la DGASPC pentru plata lunară a dobânzii."
      ],
      tips: "Creditul maxim este de 10.000€, dar crește la 20.000€ pentru mașini special adaptate."
    },
    { title: "Transport Urban și Interurban Gratuit (Art. 21)", body: "Gratuitate pe toate liniile de suprafață și metrou, plus transport interurban (auto/CFR). Valabil și pentru însoțitori/asistenți." },
    { title: "Scutire Rovinietă și Parcare", body: "Scutire de taxă de drum și drept de parcare gratuită (Card European de Parcare)." }
  ],
  taxe: [
    {
      title: "Procedură Scutiri Impozite Locale",
      body: "Scutirea pentru casă și mașină nu se aplică automat.",
      steps: [
        "Depui declarația tip la DITL (Impozite și Taxe) din orașul/sectorul tău.",
        "Anexezi copia certificatului de handicap și a actelor de proprietate.",
        "Depune până la 31 martie pentru a beneficia în anul curent."
      ]
    },
    { title: "Impozit pe Venit și Salarii", body: "Scutire de 100% pentru venituri din salarii și pensii (doar pentru handicap grav și accentuat)." },
    {
      title: "⚠️ ALERTĂ FISCALĂ 2026: ÎNAINTE vs DUPĂ",
      isNew: true,
      body: "ÎNAINTE: Scutirea era automată și obligatorie la nivel național.\n\nDUPĂ: Din 2026, scutirea devine OPȚIONALĂ la nivel local. Primăriile vor decide anual dacă o mențin, o reduc la 50% sau o elimină.",
      tips: "Urmăriți Hotărârile de Consiliu Local din orașul dvs. la finalul anului 2025!"
    }
  ],
  munca: [
    { title: "Unități Protejate Autorizate (UPA)", body: "Companiile care angajează minim 30% persoane cu handicap pot vinde produse scutite de 'Taxa pe handicap', ajutând la integrare." },
    { title: "Drepturile Angajatului (Art. 82)", body: "Perioadă de probă de 45 zile (față de standard), preaviz de 30 zile la concediere și program de lucru redus la cerere." }
  ],
  educatie: [
    { title: "Educația gratuită (Art. 14)", body: "Masă și cazare gratuită în internate (elevi). 50% reducere la cămine/cantine (studenți)." },
    { title: "Pensia și Reducerea Vârstei", body: "Pensionare redusă cu până la 15 ani în funcție de vechimea înscrisă în condiții de handicap." }
  ],
  altele: [
    {
      title: "Asistență Juridică Gratuită (Avocat din Oficiu)",
      body: "Ai dreptul la un avocat gratuit pentru cauze civile, administrative sau de discriminare.",
      steps: [
        "Mergi la Baroul de avocați din județul tău (Serviciul de asistență judiciară).",
        "Depui cererea de asistență judiciară gratuită.",
        "Anexezi certificatul de handicap și dovada lipsei veniturilor superioare pragului stabilit de lege."
      ],
      tips: "Poți invoca Legea 448/2006 pentru a cere avocat gratuit chiar și pentru simpla redactare a unor petiții legale."
    },
    {
      title: "Prioritate Locuințe Sociale și Subvenții",
      body: "Persoanele cu handicap au prioritate la primirea locuințelor de la primărie și scutire de chirie în casele statului.",
      steps: [
        "Depune cererea la Serviciul Fond Locativ al Primăriei.",
        "Solicită adaptarea mediului (rampe, lărgirea ușilor) dacă locuiești într-o clădire de stat.",
        "Cere subvenționarea chiriei pe piața privată (unde bugetul local permite, conform Legii)."
      ]
    },
    {
      title: "Convenția ONU - Dreptul la viață independentă",
      body: "Standardul internațional care obligă statul să te trateze ca cetățean cu drepturi depline, NU ca obiect de protecție.",
      tips: "Principiul de bază: 'Nimic despre noi, fără noi!'. Dacă drepturile tale naționale sunt restricționate abuziv, Convenția ONU are prioritate de invingere în instanță."
    }
  ],
  utilitati: [
    {
      title: "Scutire Facturi TV și Radio",
      body: "Scutire 100% de la taxa TV și Radio pentru handicap grav și accentuat.",
      steps: [
        "Trimite copia certificatului de handicap către Societatea Română de Televiziune (SRTV).",
        "Trimite copia către Societatea Română de Radiodifuziune (SRR)."
      ]
    }
  ],
  modificari: [
    {
      title: "🔄 OUG 90/2025: Card Electronic Transport",
      isNew: true,
      body: "ÎNAINTE: Bilete de hârtie fizice care ajungeau greu la destinație.\n\nDUPĂ: Card electronic ce se alimentează automat cu 1500 lei/an pentru carburant, vehicule electrice, mijloace CFR sau transport auto. Elimină birocrația de la ghișeu."
    },
    {
      title: "💰 OUG 127/2024: Noua Indemnizație de Solidaritate",
      isNew: true,
      body: "ÎNAINTE: Beneficiai de un bonus fix la punctul de pensie.\n\nDUPĂ: Primești o Indemnizație de Solidaritate independentă de punctul de pensie, ce crește anual prin indexarea la Indicatorul Social de Referință (ISR)."
    }
  ],
  grav: [
    {
      title: "Opțiunea: Asistent Personal vs. Indemnizație",
      body: "Persoanele cu handicap GRAV pot alege între un asistent personal sau o indemnizație lunară de însoțitor.",
      steps: [
        "Opțiunea 1: Asistent Personal angajat prin Primărie. Asistentul primește salariu, vechime, asigurări medicale.",
        "Opțiunea 2: Indemnizația de Însoțitor. Banii sunt virați direct persoanei cu handicap, care își gestionează singură nevoia de îngrijire."
      ],
      tips: "Indemnizația de însoțitor (grad I) de la Casa de Pensii este DIFERITĂ de asistentul de la DGASPC. Alegeți varianta cea mai avantajoasă financiar, deoarece nu se cumulează ambele tipuri de însoțitor de la stat!"
    }
  ]
};
